import api from './api';

export const createArticle = (articleData) => {
  return api.post('/api/blog/create', articleData);
};

export const updateArticle = (articleId, articleData) => {
  return api.put(`/api/blog/${articleId}`, articleData);
};

export const getMyArticles = () => {
  return api.get('/api/blog/my-articles');
};

export const deleteArticle = (articleId) => {
  return api.delete(`/api/blog/${articleId}`);
};

export const getPublishedArticles = () => {
  return api.get('/api/blog/public/all');
};

export const getArticleBySlug = (slug) => {
  return api.get(`/api/blog/public/slug/${slug}`);
};

export const getArticleById = (articleId) => {
  return api.get(`/api/blog/public/${articleId}`);
};

export const getAuthorArticles = (username) => {
  return api.get(`/api/blog/public/author/${username}`);
};

export const uploadMedia = (articleId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/api/blog/media/upload/${articleId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

